import { Icon } from '@aon/aon-tws-common-ui';
import globalVars from '@aon/aon-tws-common-ui/build/lib/globalVars.module.scss';
import React from 'react';
import Constants from '../../../constants';
import ContentConstants from '../../../contentConstants';
import { AddPlaceholderButton, AddPlaceholderContainer } from '../SharedComponents';

export interface IReplacementTagProps {
	handler: (placeholder: string) => any;
	showAccessCode: boolean;
}

interface IPlaceholderButton {
	id: string;
	placeholderText: string;
	text: string;
	backgroundColor?: string;
}

export const ReplacementTags = (props: IReplacementTagProps) => {
	const addPlaceholder = props.handler;

	const buttons: IPlaceholderButton[] = [
		{
			id: Constants.FIRST_NAME_BUTTON_ID,
			placeholderText: Constants.FIRST_NAME_PLACEHOLDER,
			text: ContentConstants.BUTTONS_ADD_FIRST_NAME,
		},
		{ id: Constants.LAST_NAME_BUTTON_ID, placeholderText: Constants.LAST_NAME_PLACEHOLDER, text: ContentConstants.BUTTONS_ADD_LAST_NAME },
		{
			id: Constants.EMAIL_ADDRESS_BUTTON_ID,
			placeholderText: Constants.EMAIL_ADDRESS_PLACEHOLDER,
			text: ContentConstants.BUTTONS_ADD_EMAIL_ADDRESS,
		},
	];

	if (props.showAccessCode) {
		buttons.push({
			id: Constants.ACCESS_CODE_BUTTON_ID,
			placeholderText: Constants.ACCESS_CODE_PLACEHOLDER,
			text: ContentConstants.BUTTONS_ADD_ACCESS_CODE,
		});
	}
	buttons.push({
		id: Constants.SURVEY_LINK_BUTTON_ID,
		placeholderText: Constants.SURVEY_LINK_PLACEHOLDER,
		text: ContentConstants.BUTTONS_ADD_SURVEY_LINK,
		backgroundColor: globalVars.mainBlue,
	});

	return <div style={{ minWidth: '120px' }}>{RenderButtons(buttons, addPlaceholder)}</div>;
};

function RenderButtons(buttons: IPlaceholderButton[], addPlaceholder: (placeholder: string) => any) {
	return buttons.map((button) => {
		return (
			<AddPlaceholderContainer key={button.id}>
				<AddPlaceholderButton
					id={button.id}
					floating={true}
					size='xs'
					onClick={() => addPlaceholder(button.placeholderText)}
					backgroundcolor={button.backgroundColor}
					aria-labelledby={`${button.id}_label`}
				>
					<Icon name='add' />
				</AddPlaceholderButton>
				<span id={`${button.id}_label`}>{button.text}</span>
			</AddPlaceholderContainer>
		);
	});
}
